<template>
    <v-container fluid class="container-full-bg-gray">
        <draggable-show-hide-dialog
            v-model="csv_one_line_dialog"
            title="Selector de Columnas CSV"
            :show_columns="csv_one_line_headers"
            :hide_columns="csv_one_line_hidden_headers"
            show_columns_header="Columnas ordenadas del CSV"
            hide_columns_header="Columnas excluidas del CSV"
            :key="'csv_one_line_dialog'+csv_one_line_dialog"
            :loading="isLoading"
            @update="updateCSVOneLineColumns"
            @cancel="csv_one_line_dialog=false"
        />
        
        <draggable-show-hide-dialog 
            v-model="csv_multi_line_dialog"
            :show_columns="csv_multi_line_headers"
            :hide_columns="csv_multi_line_hidden_headers"
            show_columns_header="Columnas ordenadas del CSV"
            hide_columns_header="Columnas excluidas del CSV"
            :key="'csv_multi_line_dialog_k'+csv_multi_line_dialog"
            :loading="isLoading"
            @update="updateCSVMultiLineColumns"
            @cancel="csv_multi_line_dialog=false"
        />

        <draggable-show-hide-dialog 
            v-model="popupBankDialog"
            title="Selector de Columnas CSV"
            :show_columns="bankDialogShow"
            :hide_columns="bankDialogHide"
            show_columns_header="Columnas ordenadas del CSV"
            hide_columns_header="Columnas excluidas del CSV"
            :key="'popupBankDialog_k'+popupBankDialog"
            :loading="isLoading"
            @update="saveSettingsColumns"
            @cancel="popupBankDialog=false"
        />
        

        <csv-fields-values
            v-model="csv_one_line_field_values_dialog"
            title="Configurar valores celdas CSV"
            @success="setSnackbar('success', 'Cambios realizados con éxito.')"
            @error="setSnackbar('error', 'Ha habido un error durante el proceso.')"
            @cancel="csv_one_line_field_values_dialog = false"
        />

        <app-modal-prompt
            v-model="diezsoftwareDialog"
            :loading="diezsoftwareCredentials.isLoading"
            @confirm="updateDiezsoftwareCredentials()"
            @cancel="diezsoftwareDialog = false"
        >
            <template #title>
               Credenciales Diez Software
            </template>
            <v-form ref="diezsoftwareCredentialsForm">
                <app-modal-container>
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="diezsoftwareCredentials.user"
                                label="Usuario"
                                name="diezsoftwareUser"
                                prepend-inner-icon="mdi-account-outline"
                                :rules="[validationRules.required]"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="diezsoftwareCredentials.password"
                                counter
                                label="Contraseña"
                                name="diezsoftwarePassword"
                                prepend-inner-icon="mdi-lock-outline"
                                :rules="[validationRules.required]"
                                type="password"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-select
                                v-model="diezsoftwareCredentials.softwareType"
                                filled
                                color="primary"
                                class="rounded-lg"
                                label="Programa"
                                item-text="label"
                                item-value="value"
                                prepend-inner-icon="mdi-laptop"
                                :items="diezsoftwareCredentials.softwareTypeOptions"
                                :rules="[validationRules.required]"
                            />
                        </app-modal-col>
                    </app-modal-row>
                </app-modal-container>
                
                
                
            </v-form>
        </app-modal-prompt>

        <app-modal-prompt
            v-model="a3Dialog"
            :loading="a3Directories.isLoading"
            @confirm="updateA3Directories()"
            @cancel="a3Dialog = false"
        >
            <template #title>
                Directorios A3
            </template>
            <app-modal-container>
                <v-form ref="a3DirectoryForm">
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="a3Directories.directory"
                                label="Directorio de A3"
                                name="a3Directory"
                                placeholder="C:\A3\A3ECO"
                                prepend-inner-icon="mdi-folder-text-outline"
                                @click="getFolder('a3Directories.directory')"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="a3Directories.exportFolder"
                                label="Directorio de exportación de A3"
                                name="a3ExportFolder"
                                placeholder="C:\A3"
                                prepend-inner-icon="mdi-export"
                                @click="getFolder('a3Directories.exportFolder')"
                            />
                        </app-modal-col>
                    </app-modal-row>
                    <app-modal-row v-if="got_feature('feature_a3_manage_automatic_uploads')">
                        <app-modal-col cols="12">
                            <v-switch 
                                label="Carga automática facturas"
                                v-model="a3Directories.automatic_upload_invoice"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-switch 
                                label="Carga automática transacciones bancarias"
                                v-model="a3Directories.automatic_upload_transaction"
                            />
                        </app-modal-col>
                    </app-modal-row>
                </v-form>
            </app-modal-container>
        </app-modal-prompt>

        <app-modal-prompt
            v-model="odooDialog"
            persistent
            :loading="odooCredentials.isLoading"
            @cancel="odooDialog = false"
            @confirm="updateOdooCredentials()"
        >
            <template #title>
                Credenciales Odoo
            </template>
            <app-modal-container>
                <v-form ref="odooCredentialsForm">
                    <app-modal-col cols="12">
                      <app-select
                          v-model="odooCredentials.version"
                          :items="odoo_versions"
                          :itemText="'name'"
                          :itemValue="'value'"
                          label="Versión"
                          @change="openOdooDialog"
                      />
                    </app-modal-col>
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="odooCredentials.user"
                                label="Usuario"
                                :rules="[validationRules.required]"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="odooCredentials.password"
                                label="Contraseña (API)"
                                :rules="[validationRules.required]"
                                type="password"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="odooCredentials.url"
                                label="URL"
                                :rules="[validationRules.required]"
                            />
                            <!-- , validationRules.url -->
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="odooCredentials.database"
                                label="Base de datos"
                            />
                        </app-modal-col>
                    </app-modal-row>
                </v-form>
            </app-modal-container>
        </app-modal-prompt>

        <app-modal-prompt
            v-model="glasofDialog"
            persistent
            
            @cancel="glasofDialog = false"
            @confirm="updateGlasofCredentials()"
        >
            <template #title>
                Configuracion Glasof
            </template>
            <app-modal-container>
                <v-form ref="glasofCredentialsForm">
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="glasofCredentials.public_folder"
                                label="Directorio público"
                                name="glasofPublicFolder"
                                prepend-inner-icon="mdi-folder-text-outline"
                                @click="getFolder('glasofCredentials.public_folder')"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="glasofCredentials.export_folder"
                                label="Directorio de exportación"
                                name="glasofExportFolder"
                                prepend-inner-icon="mdi-folder-text-outline"
                                @click="getFolder('glasofCredentials.export_folder')"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="glasofCredentials.application_path"
                                label="Directorio"
                                name="glasofApplicationPath"
                                prepend-inner-icon="mdi-folder-text-outline"
                                @click="getFolder('glasofCredentials.application_path')"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12" v-if="got_feature('feature_a3_manage_automatic_uploads')">
                            <v-switch 
                            label="Carga automática facturas"
                            v-model="glasofCredentials.automatic_upload_invoice"
                            />
                        </app-modal-col>

                        <app-modal-col class="text-center" v-if="got_feature('feature_cliente_glasof')">
                            <v-btn 
                            min-width="100%"
                            :disabled="disable_upgrade_glasof"
                            :loading="loading_upgrade_glasof_install"
                            @click="create_upgrade_glasof_install">
                                Actualizar instalación Glasof
                            </v-btn>
                        </app-modal-col>

                        <!-- <app-modal-col cols="12">
                            <v-switch 
                                label="Eliminar duplicados del fichero"
                                v-model="glasofCredentials.avoid_duplicate_lines"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-switch 
                                label="Ordenación de lineas del fichero"
                                v-model="glasofCredentials.order_lines"
                            />
                        </app-modal-col>
                        
                        <app-modal-col cols="12">
                            <v-select
                                v-model="glasofCredentials.avoid_duplicate_lines_keys"
                                :items="['factura','fecha']"
                                label="Seleccionar campos"
                                multiple
                                hint="Selecciona los elementos para comprobar la duplicidad de las facturas"
                                persistent-hint
                            ></v-select>
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-select
                                v-model="glasofCredentials.order_lines_keys"
                                :items="['factura','fecha']"
                                label="Seleccionar campos"
                                multiple
                                hint="Selecciona los elementos para realizar la ordenación"
                                persistent-hint
                            ></v-select>
                        </app-modal-col> -->
                    </app-modal-row>
                </v-form>
            </app-modal-container>
        </app-modal-prompt>

        <app-modal-prompt
            v-model="windowsDialog"
            persistent
            :loading="windowsCredentials.isLoading"
            @cancel="resetWindowsDialog()"
            @confirm="updateWindowsCredentials()"
        >

            <template #title>
                Configuración Windows
            </template>
            
            <app-modal-container>
                <v-form ref="windowsCredentialsForm">
                <app-modal-row>

                    <app-modal-col cols="12">
                        <app-text-field
                            v-model="windowsCredentials.username"
                            label="Nombre de usuario"
                            name="username"
                            prepend-inner-icon="mdi-account"
                            :rules="[validationRules.required]"
                            :maxlength="64"
                        />
                    </app-modal-col>

                    <app-modal-col cols="12">
                        <app-text-field
                        v-model="windowsCredentials.password"
                        label="Contraseña"
                        name="password"
                        :type="showWindowsPassword ? 'text' : 'password'"
                        prepend-inner-icon="mdi-lock"
                        :append-icon="showWindowsPassword ? 'mdi-eye' : 'mdi-eye-off'"
                        @click:append="showWindowsPassword = !showWindowsPassword"
                        :rules="[validationRules.required]"
                        />
                    </app-modal-col>

                    <app-modal-col cols="12">
                        <app-text-field
                            v-model="windowsCredentials.domain"
                            label="Dominio"
                            name="windowsDomain"
                            prepend-inner-icon="mdi-domain"
                            :maxlength="64"
                        />
                    </app-modal-col>
                </app-modal-row>
                </v-form>
            </app-modal-container>

        </app-modal-prompt>
        
        <app-modal-prompt
            v-model="kitDigitalDialog"
            persistent
            :loading="kitDigitalCredentials.loading"
            @cancel="resetKitDigitalDialog"
            @confirm="updateKitDigitalCredentials"
        >

        <template #title>Configuración Kit Digital</template>

        <app-modal-container>
            <v-form ref="kitDigitalForm">
            <app-modal-row>
                <app-modal-col cols="12">
                    <KitDigitalUpload
                        ref="kitUploader"
                        :auto-upload="false"
                        :show-button="false"
                        :close-on-success="true"
                        :screen-data="kitDigitalCredentials"
                        @snackbar="onSnack"
                        @done="onKitDigitalDone"
                        @close="kitDigitalDialog = false"
                        @loading="kitDigitalCredentials.loading = $event"
                        @screen-data="onScreenData"
                    />
                </app-modal-col>
            </app-modal-row>
            </v-form>
        </app-modal-container>
        </app-modal-prompt>

        <app-modal-prompt
            v-model="aplifisaDialog"
            :loading="aplifisaDirectories.isLoading"
            @confirm="updateAplifisaDirectories()"
            @cancel="aplifisaDialog = false"
        >
            <template #title>
                Directorios Aplifisa
            </template>
            <app-modal-container>
                <v-form ref="aplifisaDirectoryForm">
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="aplifisaDirectories.directory"
                                label="Directorio de Aplifisa"
                                name="aplifisaDirectory"
                                placeholder="C:\Aplifisa\AplifisaECO"
                                prepend-inner-icon="mdi-folder-text-outline"
                                @click="getFolder('aplifisaDirectories.directory')"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="aplifisaDirectories.port"
                                label="Puerto de Aplifisa"
                                name="aplifisaPort"
                                placeholder="4718"
                                prepend-inner-icon="mdi-server-network-outline"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="aplifisaDirectories.dll"
                                label="DLL de Aplifisa"
                                name="aplifisaDll"
                                placeholder="fbclient25.dll"
                                prepend-inner-icon="mdi-file-outline"
                            />
                        </app-modal-col>
                    </app-modal-row>
                </v-form>
            </app-modal-container>
        </app-modal-prompt>

        <app-modal-prompt
            v-model="contaplusDialog"
            :loading="contaplusDirectories.isLoading"
            @confirm="updateContaplusDirectories()"
            @cancel="contaplusDialog = false"
        >
            <template #title>
                Directorios Contaplus
            </template>
            <app-modal-container>
                <v-form ref="contaplusDirectoryForm">
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="contaplusDirectories.programFolder"
                                label="Directorio del Programa de Contaplus"
                                name="contaplusProgramFolder"
                                placeholder="C:/GrupoSP/CONTABLD"
                                prepend-inner-icon="mdi-folder-text-outline"
                                @click="getFolder('contaplusDirectories.programFolder')"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="contaplusDirectories.appFolder"
                                label="Directorio de la App de Contaplus"
                                name="contaplusAppFolder"
                                placeholder="CONTABLD"
                                prepend-inner-icon="mdi-folder-text-outline"
                                @click="getFolder('contaplusDirectories.appFolder')"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="contaplusDirectories.exportFolder"
                                label="Directorio de exportación de Contaplus"
                                name="contaplusExportFolder"
                                placeholder="C:/Contaplus_INMATIC"
                                prepend-inner-icon="mdi-export"
                                @click="getFolder('contaplusDirectories.exportFolder')"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-switch 
                                label="New DBF System de Contaplus"
                                v-model="contaplusDirectories.newDbfSystem"
                            />
                        </app-modal-col>
                    </app-modal-row>
                </v-form>
            </app-modal-container>
        </app-modal-prompt>

        <app-modal-prompt
            v-model="contasolDialog"
            :loading="contasolDirectories.isLoading"
            @confirm="updateContasolDirectories()"
            @cancel="contasolDialog = false"
        >
            <template #title>
                Directorios Contasol
            </template>
            <app-modal-container>
                <v-form ref="contasolDirectoryForm">
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <!-- <app-text-field
                                v-model="contasolDirectories.docsPrivateFolder"
                                label="Directorio Subida Docs Contasol"
                                name="contasolDocsPrivateFolder"
                                placeholder="C:/"
                                prepend-inner-icon="mdi-folder-arrow-up-outline"
                                @click="getFolder('contasolDirectories.docsPrivateFolder')"
                            /> -->
                            <app-text-field
                                v-model="contasolDirectories.cloudCode"
                                label="Contasol Cloud Cod Cliente"
                                name="contasolCloudCode"
                                placeholder=""
                                prepend-inner-icon="mdi-cloud-outline"
                            />
                            <app-text-field
                                v-model="contasolDirectories.directory"
                                label="Directorio de Contasol"
                                name="contasolDirectory"
                                placeholder="C:\\Software DELSOL\\CONTASOL\\Datos\\CS"
                                prepend-inner-icon="mdi-folder-text-outline"
                                @click="getFolder('contasolDirectories.directory')"
                            />
                            <app-text-field
                                v-model="contasolDirectories.directoryDocs"
                                label="D. Púb. Descarga Docs Contasol"
                                name="contasolDirectoryDocs"
                                placeholder="C:\\Software DELSOL\\CONTASOL\\Datos\\CS"
                                prepend-inner-icon="mdi-folder-arrow-down-outline"
                                @click="getFolder('contasolDirectories.directoryDocs')"
                            />
                            <app-text-field
                                v-model="contasolDirectories.dbDriver"
                                label="Db Driver Contasol"
                                name="contasolDbDriver"
                                placeholder=""
                                prepend-inner-icon="mdi-database-cog-outline"
                            />
                        </app-modal-col>

                    </app-modal-row>
                </v-form>
            </app-modal-container>
        </app-modal-prompt>

        <app-modal-prompt
            v-model="goldenDialog"
            persistent
            
            @cancel="goldenDialog = false"
            @confirm="updateGoldenCredentials()"
        >
            <template #title>
                Configuración GoldenNet
            </template>
            <app-modal-container>
                <v-form ref="goldenCredentialsForm">
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="goldenCredentials.export_folder"
                                label="Directorio de exportación"
                                name="goldenExportFolder"
                                placeholder="C:\\GoldenNet_Inmatic"
                                prepend-inner-icon="mdi-folder-text-outline"
                                @click="getFolder('goldenCredentials.export_folder')"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="goldenCredentials.public_folder"
                                label="Directorio público"
                                name="goldenPublicFolder"
                                placeholder="C:\\GoldenNet_Inmatic"
                                prepend-inner-icon="mdi-folder-text-outline"
                                @click="getFolder('goldenCredentials.public_folder')"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <v-switch 
                                label="Directorio Ficheros por empresa"
                                v-model="goldenCredentials.export_in_company_folder"
                            />
                        </app-modal-col>
                        
                        <app-modal-col cols="12">
                            <v-switch 
                                label="Base de datos SQL"
                                true-value="sql"
                                false-value="access"
                                v-model="goldenCredentials.db_extension"
                            />
                        </app-modal-col>
                    </app-modal-row>                    
                
                    <app-modal-row v-if="goldenCredentials.db_extension == 'sql'">
                            <app-modal-col cols="12">
                                <app-text-field
                                    v-model="goldenCredentials.db_user"
                                    label="Usuario DB"
                                    name="goldenDbUser"
                                    placeholder="User"
                                    prepend-inner-icon="mdi-account-outline"
                                />
                            </app-modal-col>
                            <app-modal-col cols="12">
                                <app-text-field
                                    v-model="goldenCredentials.db_password"
                                    label="Contraseña DB"
                                    type="password"
                                    name="goldenDbPassword"
                                    placeholder="Password"
                                    prepend-inner-icon="mdi-key-outline"
                                />
                            </app-modal-col>
                            <app-modal-col cols="12">
                                <app-text-field
                                    v-model="goldenCredentials.db_host"
                                    label="Host DB"
                                    name="goldenDbHost"
                                    placeholder="NOMBREEQUIPO\\GOLDENNET"
                                    prepend-inner-icon="mdi-server-network-outline"
                                />
                            </app-modal-col>
                    </app-modal-row>
                    <app-modal-row v-if="goldenCredentials.db_extension == 'access'">
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="goldenCredentials.db_path"
                                label="Directorio de datos"
                                name="goldenDbPath"
                                placeholder="CONTABLD"
                                prepend-inner-icon="mdi-database-outline"
                                @click="getFolder('goldenCredentials.db_path')"
                            />
                        </app-modal-col>
                    </app-modal-row>
                    <app-modal-row>
                        <app-modal-col cols="12" class="text-center">
                            <v-btn :disabled="disable_upgrade_goldennet" :loading="loading_upgrade_goldennet_install" @click="create_upgrade_goldennet_install">Actualizar instalación GoldenNet</v-btn>
                        </app-modal-col>                               
                    </app-modal-row>                                                
                        
                </v-form>
            </app-modal-container>
            
        </app-modal-prompt>

        <app-modal-prompt
            v-model="sageDialog"
            :loading="sageDirectories.isLoading"
            @confirm="updateSageDirectories()"
            @cancel="sageDialog = false"
        >
            <template #title>
                Directorios Sage
            </template>
            <app-modal-container>
                <v-form ref="sageDirectoryForm">
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="sageDirectories.con_db_host"
                                label="Host DB Sage50"
                                name="aplifisaDbHost"
                                placeholder=""
                                prepend-inner-icon="mdi-database-outline"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="sageDirectories.con_db_name"
                                label="Nombre DB Sage50"
                                name="aplifisaDbName"
                                placeholder=""
                                prepend-inner-icon="mdi-database-outline"
                            />
                        </app-modal-col>
                    </app-modal-row>
                </v-form>
            </app-modal-container>
        </app-modal-prompt>

        <app-modal-prompt
            v-model="sageDespDialog"
            persistent

            :loading="sageDespDirectories.isLoading"
            @confirm="updateSageDespDirectories()"
            @cancel="sageDespDialog = false"
        >
            <template #title>
                Directorios Sage Despachos
            </template>
            <app-modal-container>
                <v-form ref="sageDespDirectoryForm">
                    <app-modal-row>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="sageDespDirectories.con_public_folder"
                                label="Directorio público"
                                name=""
                                placeholder=""
                                prepend-inner-icon="mdi-folder-text-outline"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="sageDespDirectories.con_export_folder"
                                label="Directorio de exportación"
                                name=""
                                placeholder=""
                                prepend-inner-icon="mdi-folder-text-outline"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="sageDespDirectories.con_db_user"
                                label="Nombre Usuario"
                                name=""
                                placeholder=""
                                prepend-inner-icon="mdi-account-outline"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="sageDespDirectories.con_db_password"
                                label="Contraseña"
                                name=""
                                placeholder=""
                                prepend-inner-icon="mdi-key-outline"
                                :type="showPassSageDespachosDialog ? 'text' : 'password'"
                                :append-icon="showPassSageDespachosDialog ? 'mdi-eye' : 'mdi-eye-off'"
                                @click:append="showPassSageDespachosDialog = !showPassSageDespachosDialog"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="sageDespDirectories.con_db_host"
                                label="Host DB Sage Despachos"
                                name=""
                                placeholder=""
                                prepend-inner-icon="mdi-server-network-outline"
                            />
                        </app-modal-col>
                        <app-modal-col cols="12">
                            <app-text-field
                                v-model="sageDespDirectories.con_db_name"
                                label="Nombre DB Sage Despachos"
                                name=""
                                placeholder=""
                                prepend-inner-icon="mdi-database-outline"
                            />
                        </app-modal-col>
                    </app-modal-row>
                    <app-modal-row>
                        <app-modal-col cols="12" class="text-center">
                            <v-btn :disabled="disable_upgrade_sage" :loading="loading_upgrade_sage_install" @click="create_upgrade_sage_install">Actualizar guias Sage</v-btn>
                        </app-modal-col>                               
                    </app-modal-row>
                </v-form>
            </app-modal-container>
        </app-modal-prompt>

        <app-modal-prompt
            v-model="connectorDialog"
            @cancel="connectorDialog = false"
            cancel-btn-text="Cerrar"
            :show-confirm-btn="false"
        >
            <template #title>
                Configuración del Conector
            </template>
            <app-modal-container>
                <v-form ref="serviceStatusForm">
                    <app-modal-row class="mb-6">
                        <app-modal-col cols="2" class="align-center">
                            <span>Estado:</span>
                        </app-modal-col>
                        <app-modal-col cols="10">
                            <template>
                                <div class="d-flex">
                                  <div class="pa-3 rounded-circle d-inline-block" 
                                  v-bind:style="{ backgroundColor:connectorStatus.color}"></div>
                                  <div style="margin-left:10px">{{connectorStatus.version}}</div>
                                </div>
                              </template>
                        </app-modal-col>
                    </app-modal-row>

                    <app-modal-row v-if="isElectron">                        
                        <app-modal-col cols="12">
                            <v-btn color="primary" v-if="!connectorStatus.connected" @click="installService" :disabled="processingService"  min-width="100%">Instalar Servicio</v-btn>
                            <v-btn color="primary" v-if="connectorStatus.connected" @click="uninstallService" :disabled="processingService"  min-width="100%">Desinstalar Servicio</v-btn>
                        </app-modal-col>                 
                    </app-modal-row>

                    <app-modal-row v-if="!isElectron">
                        <span class="text-subtitle-2">Para gestionar el servicio es necesario abrir la aplicación de escritorio</span>
                    </app-modal-row>

                    <app-modal-row v-if="processingService" class="mt-5 align-center">
                        <app-modal-col cols="2">
                            <v-progress-circular 
                                indeterminate
                                color="primary">
                            </v-progress-circular>
                        </app-modal-col>
                        <app-modal-col>
                            <div>Procesando petición</div>
                        </app-modal-col>

                    </app-modal-row>

                </v-form>
            </app-modal-container>
        </app-modal-prompt>

        <app-modal-prompt
          v-model="autoflowDialog"
          :loading="autoflowCredentials.isLoading"
          @confirm="updateAutoflowCredentials()"
          @cancel="autoflowDialog = false"
        >
          <template #title>
            Credenciales Programas Contables
          </template>
          <v-form ref="autoflowCredentialsForm">
            <app-modal-container>
              <app-modal-row>
                <app-modal-col cols="12">
                  <app-select
                      v-model="autoflowCredentials.software"
                      filled
                      color="primary"
                      class="rounded-lg"
                      label="Programa Contable"
                      item-text="label"
                      item-value="value"
                      prepend-inner-icon="mdi-laptop"
                      :items="sortedSoftwareTypeOptions"
                      :rules="[validationRules.required]"
                      @change="onAutoflowSoftwareChange"
                      @input="onAutoflowSoftwareChange"
                  />
                </app-modal-col>

                <app-modal-col cols="12">
                  <app-text-field
                      v-model="autoflowCredentials.user"
                      label="Usuario"
                      name="softUser"
                      prepend-inner-icon="mdi-account-outline"
                      :rules="[validationRules.required]"
                  />
                </app-modal-col>
                <app-modal-col cols="12">
                  <app-text-field
                      v-model="autoflowCredentials.password"
                      counter
                      label="Contraseña"
                      name="softPassword"
                      :type="showAutoflowPassword ? 'text' : 'password'"
                      prepend-inner-icon="mdi-lock"
                      :append-icon="showAutoflowPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showAutoflowPassword = !showAutoflowPassword"
                      :rules="[validationRules.required]"
                  />
                </app-modal-col>
              </app-modal-row>
            </app-modal-container>
          </v-form>
        </app-modal-prompt>

        <app-page-card>
            <template #header>
                Configuración de conectores
            </template>
            <template>
                <app-header-with-subtitle>
                    <template #icon>
                        mdi-cog-outline
                    </template>
                    <template>
                        Configura tus conectores para aprovechar <span v-if="userData && userData.sender_docs_user_distributor_code">el programa</span> <span v-else>Inmatic</span> al máximo
                    </template>
                    <template #subtitle>
                        Aquí podrás encontras las opciones autogestionables para que logres conectar <span v-if="userData && userData.sender_docs_user_distributor_code">el programa</span> <span v-else>Inmatic</span> con otras herramientas.
                    </template>
                </app-header-with-subtitle>
                
                <app-container>
                <app-row v-if="(token && 
                                userData.hasOwnProperty('sender_docs_user') && 
                                userData.sender_docs_user != null &&
                                userData.hasOwnProperty('sender_docs_user_distributor_code') &&
                                ['processtalks', 'atinfoserveis'].includes(userData.sender_docs_user_distributor_code))">
                    <p><strong>Token:</strong> {{ this.token }}</p>
                </app-row>
                <app-row>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center">
                        <settings-card 
                            @click="previewBankDialog()"
                        >
                            <template #icon>
                                mdi-folder-text-outline
                            </template>
                            Bancos CSV
                            <template #description>
                                Configuración de CSVs para otros conectores (Bancos).
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center">
                        <settings-card 
                            
                            @click="csv_one_line_dialog = true"
                        >
                            <template #icon>
                                mdi-folder-text-outline
                            </template>
                            CSVs
                            <template #description>
                                Configuración de CSVs para otros conectores.
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col 
                        cols="12" sm="6" lg="4" xl="3" 
                        class="d-flex justify-center" 
                        v-if="userData.available_features['feature_configure_csv_fields_values']"
                    >
                        <settings-card 
                            
                            @click="csv_one_line_field_values_dialog = true"
                        >
                            <template #icon>
                                mdi-form-textbox
                            </template>
                            Valores celdas CSV
                            <template #description>
                                Títulos de las celdas en facturas de proveedor y cliente.
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center"  
                    v-if="got_feature('feature_diez_software') && !got_feature('feature_cliente_glasof')"
                    >
                        <settings-card 
                            
                            @click="openDiezSoftwareDialog()"
                        >
                            <template #icon>
                                mdi-graph-outline
                            </template>
                            Diezsoftware
                            <template #description>
                                Modificar credenciales para el conector de Diezsoftware.
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" 
                    v-if="got_feature('feature_a3_self_managing') && !got_feature('feature_cliente_glasof')"
                    >
                        <settings-card 
                             
                            @click="openA3Dialog()"
                        >
                            <template #icon>
                                mdi-graph-outline
                            </template>
                            A3
                            <template #description>
                                Configuración de las carpetas de A3.
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" v-if="!got_feature('feature_cliente_glasof')">
                        <settings-card
                            @click="openOdooDialog()"
                        >
                            <template #icon>
                                mdi-graph-outline
                            </template>
                            <template>
                                Odoo
                            </template>
                            <template #description>
                                Modificar credenciales para el conector de Odoo
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" 
                    v-if="got_feature('feature_aplifisa_self_managing') && !got_feature('feature_cliente_glasof')"
                    >
                        <settings-card 

                            @click="openAplifisaDialog()"
                        >
                            <template #icon>
                                mdi-graph-outline
                            </template>
                            Aplifisa
                            <template #description>
                                Configuración de las carpetas de Aplifisa.
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" 
                    v-if="got_feature('feature_contaplus_self_managing') && !got_feature('feature_cliente_glasof')"
                    >
                        <settings-card 

                            @click="openContaplusDialog()"
                        >
                            <template #icon>
                                mdi-graph-outline
                            </template>
                            Contaplus
                            <template #description>
                                Configuración de las carpetas de Contaplus.
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" 
                    v-if="got_feature('feature_contasol_self_managing') && !got_feature('feature_cliente_glasof')"
                    >
                        <settings-card 

                            @click="openContasolDialog()"
                        >
                            <template #icon>
                                mdi-graph-outline
                            </template>
                            Contasol
                            <template #description>
                                Configuración de las carpetas de Contasol.
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center">
                        <settings-card
                            @click="openGlasofDialog()"
                        >
                            <template #icon>
                                mdi-graph-outline
                            </template>
                            <template>
                                Glasof
                            </template>
                            <template #description>
                                Modificar configuracion para el conector de Glasof
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" v-if="!got_feature('feature_cliente_glasof')">
                        <settings-card
                            @click="openGoldenDialog()"
                        >
                            <template #icon>
                                mdi-graph-outline
                            </template>
                            <template>
                                Goldennet
                            </template>
                            <template #description>
                                Modificar configuracion para el conector de Goldennet
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center">
                        <settings-card
                            @click="openWindowsDialog()"
                        >
                            <template #icon>
                                mdi-graph-outline
                            </template>
                            <template>
                                Windows
                            </template>
                            <template #description>
                                Configurar credenciales del usuario.
                            </template>
                        </settings-card>
                    </app-col>

                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" v-if="userData && userData.is_staff">
                        <settings-card @click="openKitDigitalDialog">
                            <template #icon>
                            mdi-graph-outline
                            </template>
                            <template>
                            Kit Digital
                            </template>
                            <template #description>
                            Enviar Kit Digital a Hubspot.
                            </template>
                        </settings-card>
                    </app-col>

                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" 
                    v-if="got_feature('feature_sage_self_managing') && !got_feature('feature_cliente_glasof')"
                    >
                        <settings-card
                            @click="openSageDialog()"
                        >
                            <template #icon>
                                mdi-graph-outline
                            </template>
                            <template>
                                Sage
                            </template>
                            <template #description>
                                Modificar configuracion para el conector de Sage
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" 
                    v-if="got_feature('feature_sage_self_managing') && !got_feature('feature_cliente_glasof')"
                    >
                        <settings-card
                            @click="openSageDespDialog()"
                        >
                            <template #icon>
                                mdi-graph-outline
                            </template>
                            <template>
                                Sage Despachos
                            </template>
                            <template #description>
                                Modificar configuracion para el conector de Sage Despachos
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center"
                             v-if="got_feature('feature_autoflow_import_invoice')"
                    >
                      <settings-card
                          @click="openAutoflowDialog()"
                      >
                        <template #icon>
                          <!-- Icon that represents Action Automation -->
                          mdi-call-split
                        </template>
                        <template>
                          Autoflow
                        </template>
                        <template #description>
                          Configura credenciales de programa contable
                        </template>
                      </settings-card>
                    </app-col>
                    <app-col cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center" v-if="isElectron">
                        <settings-card
                            @click="openConnectorDialog"
                        >
                            <template #icon>
                                mdi-progress-wrench
                            </template>
                            <template>
                                Estado del Servicio
                            </template>
                            <template #description>
                                Comprobar y gestionar el estado del servicio
                            </template>
                        </settings-card>
                    </app-col>
                    <!-- <app-col v-if=false cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center">
                        <settings-card
                            @click="openOdooDialog()"
                        >
                            <template #icon>
                                mdi-graph-outline
                            </template>
                            <template>
                                Golden
                            </template>
                            <template #description>
                                Modificar configuración para el conector de Golden
                            </template>
                        </settings-card>
                    </app-col>
                    <app-col v-if=false cols="12" sm="6" lg="4" xl="3" class="d-flex justify-center">
                        <settings-card
                            @click="showConnectorIdsList=true"
                            >
                                <template>
                                    Conectores
                                </template>
                                <template #description>
                                    Modificar Conector activo
                                </template>
                        </settings-card>
                        <ConnectorIdsList @close-dialog="showConnectorIdsList=false" :show_message="showConnectorIdsList"> </ConnectorIdsList>
                    </app-col> -->
                </app-row>
                </app-container>
            </template>
        </app-page-card>
        <v-snackbar
            v-model="snackbar.isVisible"
            :color="snackbar.color"
            :timeout="snackbar.timeout"
        >
            {{ snackbar.text }}
        </v-snackbar>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { mapFields } from 'vuex-map-fields';
import { vuexPrefix } from "../store/vuex_utils";
import AppHeaderWithSubtitle from '@/components/layout/AppHeaderWithSubtitle.vue';
import AppPageCard from '@/components/layout/AppPageCard.vue';
import DraggableShowHideDialog from '../components/DraggableShowHideDialog.vue';
import DocTextField from '../components/DocTextField.vue';
import CsvFieldsValues from '../components/CsvFieldsValues.vue'
import SettingsCard from '@/components/settings/SettingsCard.vue';
import AppContainer from '@/components/layout/AppContainer.vue';
import AppCol from '@/components/layout/AppCol.vue';
import AppRow from '@/components/layout/AppRow.vue';
import AppModalCol from '@/components/layout/AppModalCol.vue';
import AppModalContainer from '@/components/layout/AppModalContainer.vue';
import AppModalPrompt from '@/components/layout/AppModalPrompt.vue';
import AppModalRow from '@/components/layout/AppModalRow.vue';
import AppTextField from '@/components/layout/AppTextField.vue';
import AppSelect from '@/components/layout/AppSelect.vue';
import { createApiTokenRepository } from '@/modules/tokens/infrastructure/ApiTokenRepository';
import { getOrCreateToken } from '@/modules/tokens/application/getOrCreateToken';
import { getToken } from '@/modules/tokens/application/getToken';
import { client, sync_command_dispatcher, query_dispatcher } from "@/api/client";
import ConnectorIdsList from '@/modules/conector_ops/infra/ConnectorIdsList';
import { GetBankSettingsQuery } from '@/modules/bank/application/GetBankSettings'
import { SaveBankSettingsCommand } from '@/modules/bank/application/SaveBankSettings'
import { ApiBankRepository } from '@/modules/bank/infra/SettingsRepository'
import KitDigitalUpload from "@/views/KitDigitalUpload.vue";

export default {
    components: {
        AppHeaderWithSubtitle,
        AppModalCol,
        AppModalContainer,
        AppModalPrompt,
        AppModalRow,
        AppPageCard,
        AppSelect,
        AppTextField,
        DraggableShowHideDialog,
        DocTextField,
        CsvFieldsValues,
        SettingsCard,
        AppContainer,
        AppCol,
        AppRow,
        ConnectorIdsList,
        KitDigitalUpload
    },
    computed: {
        ...mapFields('config', {
            csv_one_line_headers: 'csv_one_line_headers',
            csv_one_line_hidden_headers: 'csv_one_line_hidden_headers',
            csv_multi_line_headers: 'csv_multi_line_headers',
            csv_multi_line_hidden_headers: 'csv_multi_line_hidden_headers',
         
        }),
        ...mapFields('me',vuexPrefix('',[
            'feature_iva_agrario_pesca_tabaco',
        ],'userData.available_features.')),
        ...mapGetters({
            userData: 'me/userData',
            got_feature: 'got_feature',
        }),
        sortedSoftwareTypeOptions() {
            const items = (this.autoflowCredentials && Array.isArray(this.autoflowCredentials.softwareTypeOptions))
                ? this.autoflowCredentials.softwareTypeOptions
                : []
            return [...items].sort((a, b) => {
                const al = (a && a.label ? a.label : '').toString()
                const bl = (b && b.label ? b.label : '').toString()
                return al.localeCompare(bl, 'es', { sensitivity: 'base' })
            })
        },
    },

    data() {
        return {
            //TODO: Revisar si emailRegex y urlRegex se pueden borrar
            emailRegex: new RegExp(/^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i),
            urlRegex: new RegExp(/^(ftp|http|https):\/\/[^ "]+$/),
            currantCSVTab: 0,
            csv_one_line_dialog: false,
            csv_multi_line_dialog: false,
            csv_one_line_field_values_dialog: false,
            diezsoftwareDialog: false,
            a3Dialog: false,
            odooDialog: false,
            glasofDialog: false,
            windowsDialog: false,
            goldenDialog: false,
            aplifisaDialog: false,
            contaplusDialog: false,
            contasolDialog: false,
            sageDialog: false,
            sageDespDialog: false,
            connectorDialog: false,
            autoflowDialog: false,
            isLoading: false,
            minimumPasswordLength: 4,
            processingService: false,
            connectorStatus: {color: 'grey', text: '?', status: ''},
            loading_upgrade_goldennet_install: false,
            loading_upgrade_sage_install: false,
            loading_upgrade_glasof_install: false,
            disable_upgrade_goldennet: false,
            disable_upgrade_sage: false,
            disable_upgrade_glasof: false,
            odoo_versions: [
                { name: 'Odoo 15-17', value: 'odoo' },
                { name: 'Odoo 18', value: 'odoo18' },
            ],
            diezsoftwareCredentials: {
                user: '',
                password: '',
                software: '',
                isLoading: false,

                softwareTypeOptions: [
                    {
                        label: 'DiezCon',
                        value: 'Contabilidad'
                    },
                    {
                        label: 'DiezERP',
                        value: 'ERP'
                    }
                ]
            },

            odooCredentials: {
                user: '',
                password: '',
                url: '',
                database: '',
                isLoading: false,
            },

            glasofCredentials:{
                automatic_upload_invoice: false,
                // avoid_duplicate_lines: false,
                // avoid_duplicate_lines_keys: [],
                // order_lines: false,
                // order_lines_keys: [],
                public_folder: '',
                export_folder: '',
                application_path: '',
            },
            windowsCredentials: {
                username: '',
                password: '',
                domain: '',
                isLoading: false,
            },
            showWindowsPassword: false,
            goldenCredentials:{
                public_folder: '',
                export_in_company_folder: false,
                db_path: '',
                db_user: '',
                db_password: '',
                db_host: '',
                db_extension: 'access',
                export_folder: '',
                
            },

            a3Directories: {
                directory: '',
                exportFolder: '',
                automatic_upload_transaction: false,
                automatic_upload_invoice: false,
                isLoading: false,
            },

            aplifisaDirectories: {
                directory: '',
                port: '',
                dll: '',
                isLoading: false,
            },
            contaplusDirectories: {
                programFolder: '',
                appFolder: '',
                exportFolder: '',
                newDbfSystem: '',
                isLoading: false,
            },
            contasolDirectories: {
                // docsPrivateFolder: '',
                dbDriver: '',
                directory: '',
                directoryDocs: '',
                cloudCode: '',
                isLoading: false,
            },
            sageDirectories: {
                con_db_host: '',
                con_db_name: '',
                isLoading: false,
            },
            sageDespDirectories: {
                con_db_host: '',
                con_db_name: '',
                con_db_user: '',
                con_db_password: '',
                con_public_folder: '',
                con_export_folder: '',
                isLoading: false,
            },

            autoflowCredentials: {
              software: '',
              user: '',
              password: '',
              isLoading: false,
              softwareTypeOptions: []
            },
            showAutoflowPassword: false,

            validationRules: {
                required: v => !!v || 'Campo obligatorio',
                minimumLength: v => v.length >= this.minimumPasswordLength || `Mínimo ${this.minimumPasswordLength} caracteres`,
                email: v => v.match(this.emailRegex) || 'Introduzca un email válido',
                url: v => v.match(this.urlRegex) || 'Introduzca una URL válida',
            },

            snackbar: {
                isVisible: false,
                text: '',
                color: '',
                timeout: 2000,
            },

            isElectron: false,
            token: '',
            showConnectorIdsList: false,
            showPassSageDespachosDialog: false,

            popupBankDialog: false,
            bankDialogShow: [],
            bankDialogHide: [],
            kitDigitalDialog: false,
            kitDigitalCredentials: {
                    path: null,
                    loading: false
                }
        }
    },
    methods: {
        ...mapActions({
            getColumnsCsvOneLine: "config/getColumnsCsvOneLine",
            setColumnsCsvOneLine: "config/setColumnsCsvOneLine",
            getColumnsCsvMultiLine: "config/getColumnsCsvMultiLine",
            setColumnsCsvMultiLine: "config/setColumnsCsvMultiLine",
            setDiezsoftwareCredentials: "config/setDiezsoftwareCredentials",
            setA3Directories: "config/setA3Directories",
            setOdooCredentials: "config/setOdooCredentials",
            setAplifisaDirectories: "config/setAplifisaDirectories",
            setContaplusDirectories: "config/setContaplusDirectories",
            setContasolDirectories: "config/setContasolDirectories",
            setGlasofCredentials: "config/setGlasofCredentials",
            setGoldenCredentials: "config/setGoldenCredentials",
            setSageCredentials: "config/setSageCredentials",
            setSageDespCredentials : "config/setSageDespCredentials",
            refreshUserData: "me/refreshUserData",
            forceRefreshUserData: "me/forceRefreshUserData",
        }),
        updateCSVOneLineColumns(data) {
            this.csv_one_line_headers = data['show']
            this.csv_one_line_hidden_headers = data['hide']
            this.isLoading = true

            this.setColumnsCsvOneLine().then(() => {
                this.setSnackbar('success', 'Cambios realizados con éxito.')
                setTimeout(() => {this.csv_one_line_dialog = false}, 500)
            }).catch(() => {
                this.setSnackbar('error', 'Ha habido un error durante el proceso.')
                this.csv_one_line_dialog = false;
            }).finally(() => {
                this.isLoading = false
            })
        },
        updateCSVMultiLineColumns(data) {
            this.csv_multi_line_headers = data['show']
            this.csv_multi_line_hidden_headers = data['hide']
            this.isLoading = true

            this.setColumnsCsvMultiLine().then(() => {
                this.setSnackbar('success', 'Cambios realizados con éxito.')
                setTimeout(() => {this.csv_multi_line_dialog = false}, 500)
            }).catch(() => {
                this.setSnackbar('error', 'Ha habido un error durante el proceso.')
                this.csv_multi_line_dialog = false;
            }).finally(() => {
                this.isLoading = false
            })
        },

        openDiezSoftwareDialog() {
            this.diezsoftwareDialog = true;
        },

        openOdooDialog() {
            if (!this.odooDialog) {
              if (this.userData.default_settings.odoo) {
                this.odooCredentials.user = this.userData.default_settings.odoo.con_user || ''
                this.odooCredentials.password = this.userData.default_settings.odoo.con_password || ''
                this.odooCredentials.database = this.userData.default_settings.odoo.con_db || ''
                this.odooCredentials.url = this.userData.default_settings.odoo.con_url || ''
                this.odooCredentials.version = 'odoo'
              } else if (this.userData.default_settings.odoo18) {
                this.odooCredentials.user = this.userData.default_settings.odoo18.con_user || ''
                this.odooCredentials.password = this.userData.default_settings.odoo18.con_password || ''
                this.odooCredentials.database = this.userData.default_settings.odoo18.con_db || ''
                this.odooCredentials.url = this.userData.default_settings.odoo18.con_url || ''
                this.odooCredentials.version = 'odoo18'
              } else {
                this.odooCredentials.version = 'odoo';
              }
            }else{
              if (this.odooCredentials.version === 'odoo' && this.userData.default_settings.odoo) {
                this.odooCredentials.user = this.userData.default_settings.odoo.con_user || ''
                this.odooCredentials.password = this.userData.default_settings.odoo.con_password || ''
                this.odooCredentials.database = this.userData.default_settings.odoo.con_db || ''
                this.odooCredentials.url = this.userData.default_settings.odoo.con_url || ''
              } else if (this.odooCredentials.version === 'odoo18' && this.userData.default_settings.odoo18) {
                this.odooCredentials.user = this.userData.default_settings.odoo18.con_user || ''
                this.odooCredentials.password = this.userData.default_settings.odoo18.con_password || ''
                this.odooCredentials.database = this.userData.default_settings.odoo18.con_db || ''
                this.odooCredentials.url = this.userData.default_settings.odoo18.con_url || ''
              } else {
                this.odooCredentials.user = ''
                this.odooCredentials.password = ''
                this.odooCredentials.database = ''
                this.odooCredentials.url = ''
              }
            }
            this.odooDialog = true;
        },

        openGlasofDialog() {
            if (this.userData.default_settings.glasof) {
                // this.glasofCredentials.avoid_duplicate_lines = this.userData.default_settings.glasof.avoid_duplicate_lines
                // this.glasofCredentials.avoid_duplicate_lines_keys = this.userData.default_settings.glasof.avoid_duplicate_lines_keys
                this.glasofCredentials.automatic_upload_invoice = this.userData.default_settings.glasof.automatic_upload_invoice
                // this.glasofCredentials.order_lines = this.userData.default_settings.glasof.order_lines
                // this.glasofCredentials.order_lines_keys = this.userData.default_settings.glasof.order_lines_keys
                this.glasofCredentials.public_folder = this.userData.default_settings.glasof.public_folder
                this.glasofCredentials.export_folder = this.userData.default_settings.glasof.export_folder
                this.glasofCredentials.application_path = this.userData.default_settings.glasof.application_path

            }
            this.glasofDialog = true;
        },

        openWindowsDialog() {
            this.windowsDialog = true;
        },

        async resetWindowsDialog() {

            this.windowsDialog = false

            await this.getWindowsConfig()
        
            this.$refs.windowsCredentialsForm.resetValidation()
        },

        updateWindowsCredentials() {

            this.windowsCredentials.isLoading = true;

            const formIsValid = this.$refs.windowsCredentialsForm.validate();

            if (!formIsValid) {
                this.setSnackbar('error', 'Por favor, rellena los campos obligatorios.');
                this.windowsCredentials.isLoading = false;
                return;
            }

            const payload = {
                username: this.windowsCredentials.username,
                password: this.windowsCredentials.password,
                domain: this.windowsCredentials.domain,
            };

            sync_command_dispatcher.dispatch('save.windows.config.encrypted',{info:payload} )
                .then(() => {
                    this.setSnackbar('success', 'Credenciales guardadas correctamente.');
                    this.windowsDialog = true;

                setTimeout(() => {
                    this.windowsDialog = false;
                    this.windowsCredentials.isLoading = false; 
                }, 500);
                })
                .catch(() => {
                    this.setSnackbar('error', 'Error al guardar las credenciales.');
                    this.windowsCredentials.isLoading = false; 
                });
        },

        false_if_empty_or_undefined(data){
            return data !== undefined && data !== '' ? data : false;
        },

        openGoldenDialog() {
            if (this.userData.default_settings.goldennet ) {
                this.goldenCredentials.public_folder = this.userData.default_settings.goldennet.public_folder
                this.goldenCredentials.export_in_company_folder = this.false_if_empty_or_undefined(this.userData.default_settings.goldennet.export_in_company_folder)
                this.goldenCredentials.db_extension = this.userData.default_settings.goldennet.db_extension
                this.goldenCredentials.export_folder = this.userData.default_settings.goldennet.export_folder
                if (this.goldenCredentials.db_extension == 'sql') {
                    this.goldenCredentials.db_user = this.userData.default_settings.goldennet.db_user
                    this.goldenCredentials.db_password = this.userData.default_settings.goldennet.db_password
                    this.goldenCredentials.db_host = this.userData.default_settings.goldennet.db_host
                } else {
                    this.goldenCredentials.db_path = this.userData.default_settings.goldennet.con_db_path
                }

                // this.goldenCredentials.avoid_duplicate_lines = this.userData.default_settings.goldennet.avoid_duplicate_lines
                // this.goldenCredentials.avoid_duplicate_lines_keys = this.userData.default_settings.goldennet.avoid_duplicate_lines_keys
                // this.goldenCredentials.automatic_upload = this.userData.default_settings.goldennet.automatic_upload
                // this.goldenCredentials.order_lines = this.userData.default_settings.goldennet.order_lines
                // this.goldenCredentials.order_lines_keys = this.userData.default_settings.goldennet.order_lines_keys
            }
            this.goldenDialog = true;
        },

        openA3Dialog() {
            if (this.userData.default_settings.con_directory_a3) {
                this.a3Directories.directory = this.userData.default_settings.con_directory_a3
            }
            if (this.userData.default_settings.a3 && this.userData.default_settings.a3.files_directory) {
                this.a3Directories.exportFolder = this.userData.default_settings.a3.files_directory
            }
            if (this.userData.default_settings.a3 && this.userData.default_settings.a3.automatic_upload_invoice) {
                this.a3Directories.automatic_upload_invoice = this.userData.default_settings.a3.automatic_upload_invoice
            }
            if (this.userData.default_settings.a3 && this.userData.default_settings.a3.automatic_upload_transaction) {
                this.a3Directories.automatic_upload_transaction = this.userData.default_settings.a3.automatic_upload_transaction
            }
            this.a3Dialog = true;
        },

        openAplifisaDialog() {
            if (this.userData.default_settings.con_dll_aplifisa) {
                this.aplifisaDirectories.dll = this.userData.default_settings.con_dll_aplifisa
            }
            if (this.userData.default_settings.con_port_aplifisa) {
                this.aplifisaDirectories.port = this.userData.default_settings.con_port_aplifisa
            }
            if (this.userData.default_settings.con_directory_aplifisa) {
                this.aplifisaDirectories.directory = this.userData.default_settings.con_directory_aplifisa
            }
            this.aplifisaDialog = true;
        },

        openContasolDialog() {
            // if (this.userData.default_settings.docs_private_folder) {
            //     this.contasolDirectories.docsPrivateFolder = this.userData.default_settings.docs_private_folder
            // }
            if (this.userData.default_settings.con_db_driver_contasol) {
                this.contasolDirectories.dbDriver = this.userData.default_settings.con_db_driver_contasol
            }
            if (this.userData.default_settings.con_directory_contasol) {
                this.contasolDirectories.directory = this.userData.default_settings.con_directory_contasol
            }
            if (this.userData.default_settings.con_directory_docs_contasol) {
                this.contasolDirectories.directoryDocs = this.userData.default_settings.con_directory_docs_contasol
            }
            if (this.userData.default_settings.contasol_cloud_codigo_cliente) {
                this.contasolDirectories.cloudCode = this.userData.default_settings.contasol_cloud_codigo_cliente
            }
            this.contasolDialog = true;
        },

        openContaplusDialog() {
            if (this.userData.default_settings.contaplus) {
                this.contaplusDirectories.programFolder = this.userData.default_settings.contaplus.con_application_group_path
                this.contaplusDirectories.appFolder = this.userData.default_settings.contaplus.con_application_folder_path
                this.contaplusDirectories.exportFolder = this.userData.default_settings.contaplus.con_export_folder
                this.contaplusDirectories.newDbfSystem = this.userData.default_settings.contaplus.con_new_read_dbf_system
            }
            this.contaplusDialog = true;
        },

        openSageDialog() {
            if (this.userData.default_settings.sage) {
                this.sageDirectories.con_db_host = this.userData.default_settings.sage.con_db_host
                this.sageDirectories.con_db_name = this.userData.default_settings.sage.con_db_name
            }
            this.sageDialog = true;
        },

        initSageDespDialog() {
            if (this.userData.default_settings.sage_despachos) {
                this.sageDespDirectories.con_db_host = this.userData.default_settings.sage_despachos.con_db_host
                this.sageDespDirectories.con_db_name = this.userData.default_settings.sage_despachos.con_db_name
                this.sageDespDirectories.con_db_user = this.userData.default_settings.sage_despachos.con_db_user
                this.sageDespDirectories.con_db_password = this.userData.default_settings.sage_despachos.con_db_password
                this.sageDespDirectories.con_public_folder = this.userData.default_settings.sage_despachos.con_public_folder
                this.sageDespDirectories.con_export_folder = this.userData.default_settings.sage_despachos.con_export_folder
            }
        },

        openSageDespDialog() {
            this.sageDespDialog = true;
        },

        openConnectorDialog() {
            this.checkConnectorStatus();
            this.connectorDialog = true;
        },

        async fetchAutoflowSoftwareTypes() {
          try {
            const resp = await client.get('get_user_companydb_types/')
            const types = Array.isArray(resp.data && resp.data.companydb_types) ? resp.data.companydb_types : []
            const values_to_delete = ['csv_asientos', 'csv_facturas', 'generic', 'inbox', 'generic', 'ncs_director', 'solo_bancos', 'api_facturas', 'sage']
            const filtered_types = types.filter(type => !values_to_delete.includes(type.value))
            this.autoflowCredentials.softwareTypeOptions = filtered_types.map(t => ({ label: t.name || t.value, value: t.value }))
          } catch (e) {
            this.setSnackbar('error', 'No se pudieron cargar los programas contables.')
          }
        },

        async openAutoflowDialog() {
          this.autoflowCredentials.isLoading = true
          try {
            await this.fetchAutoflowSoftwareTypes()
          } finally {
            this.autoflowCredentials.isLoading = false
            this.autoflowDialog = true
            // Auto-load saved credentials for preselected software
            if (this.autoflowCredentials.software) {
              this.loadSoftwareCredentials(this.autoflowCredentials.software)
            }
          }
        },

        onAutoflowSoftwareChange(val) {
          if (!this.autoflowDialog) return
          const software = typeof val === 'string' ? val : this.autoflowCredentials.software
          if (!software) {
            this.autoflowCredentials.user = ''
            this.autoflowCredentials.password = ''
            return
          }
          this.loadSoftwareCredentials(software)
        },

        async loadSoftwareCredentials(soft) {
          try {
            this.autoflowCredentials.isLoading = true
            const res = await query_dispatcher.dispatch('get.software.credentials.decrypted', {
              software: soft
            })
            console.log('loadSoftwareCredentials', res);
            if (res) {
              this.autoflowCredentials.user = res.user || ''
              this.autoflowCredentials.password = res.password || ''
            } else {
              this.autoflowCredentials.user = ''
              this.autoflowCredentials.password = ''
            }
          } catch (e) {
            // If there is an error, clear fields to avoid mismatch and notify user
            this.autoflowCredentials.user = ''
            this.autoflowCredentials.password = ''
            this.setSnackbar('error', 'No se pudieron cargar las credenciales del programa seleccionado.')
          } finally {
            this.autoflowCredentials.isLoading = false
          }
        },

        updateDiezsoftwareCredentials() {
            this.diezsoftwareCredentials.isLoading = true
            const formIsValid = this.$refs.diezsoftwareCredentialsForm.validate()

            if(!this.got_feature('feature_diez_software')) {
                this.setSnackbar('error', 'No tiene los permisos adecuados para modificar estos valores.')
            }

            if (formIsValid) {
                this.setDiezsoftwareCredentials(this.diezsoftwareCredentials)
                .then((res) => {
                    if (res.default_settings && res.default_settings.diezsoftware) {
                        this.diezsoftwareCredentials.user = res.default_settings.diezsoftware.user
                        this.diezsoftwareCredentials.password = res.default_settings.diezsoftware.password
                        this.diezsoftwareCredentials.softwareType = res.default_settings.diezsoftware.software_type
                    }
                    this.setSnackbar('success', 'Cambios realizados con éxito.')
                    
                    setTimeout(() => {this.diezsoftwareDialog = false}, 500)
                })
                .catch(() => { this.setSnackbar('error', 'Ha habido un error durante el proceso.') })
                .finally(() => {
                    this.diezsoftwareCredentials.isLoading = false
                })
            } else {
                this.diezsoftwareCredentials.isLoading = false
                this.setSnackbar('error', 'Compruebe que los valores en el formulario son válidos.')
            }


        },

        updateA3Directories() {
            this.a3Directories.isLoading = true

            if(!this.got_feature('feature_a3_self_managing')) {
                this.setSnackbar('error', 'No tiene los permisos adecuados para modificar estos valores.')
            }

            this.setA3Directories(this.a3Directories)
            .then(() => {
                this.setSnackbar('success', 'Cambios realizados con éxito.') 
                setTimeout(() => {this.a3Dialog = false}, 500)
            })
            .catch(() => { this.setSnackbar('error', 'Ha habido un error durante el proceso.') })
            .finally(() => {
                this.a3Directories.isLoading = false
            })

        },

        updateAplifisaDirectories() {
            this.aplifisaDirectories.isLoading = true

            if(!this.got_feature('feature_aplifisa_self_managing')) {
                this.setSnackbar('error', 'No tiene los permisos adecuados para modificar estos valores.')
            }

            this.setAplifisaDirectories(this.aplifisaDirectories)
            .then(() => {
                this.setSnackbar('success', 'Cambios realizados con éxito.') 
                setTimeout(() => {this.a3Dialog = false}, 500)
            })
            .catch(() => { this.setSnackbar('error', 'Ha habido un error durante el proceso.') })
            .finally(() => {
                this.aplifisaDirectories.isLoading = false
            })
        },

        updateContaplusDirectories() {
            this.contaplusDirectories.isLoading = true

            if(!this.got_feature('feature_contaplus_self_managing')) {
                this.setSnackbar('error', 'No tiene los permisos adecuados para modificar estos valores.')
            }

            this.setContaplusDirectories(this.contaplusDirectories)
            .then(() => {
                this.setSnackbar('success', 'Cambios realizados con éxito.') 
                setTimeout(() => {this.a3Dialog = false}, 500)
            })
            .catch(() => { this.setSnackbar('error', 'Ha habido un error durante el proceso.') })
            .finally(() => {
                this.contaplusDirectories.isLoading = false
            })
        },

        updateContasolDirectories() {
            this.contasolDirectories.isLoading = true

            if(!this.got_feature('feature_contasol_self_managing')) {
                this.setSnackbar('error', 'No tiene los permisos adecuados para modificar estos valores.')
            }

            this.setContasolDirectories(this.contasolDirectories)
            .then(() => {
                this.setSnackbar('success', 'Cambios realizados con éxito.') 
                setTimeout(() => {this.a3Dialog = false}, 500)
            })
            .catch(() => { this.setSnackbar('error', 'Ha habido un error durante el proceso.') })
            .finally(() => {
                this.contasolDirectories.isLoading = false
            })
        },

        updateOdooCredentials() {
            this.odooCredentials.isLoading = true
            const formIsValid = this.$refs.odooCredentialsForm.validate()

            if(!this.got_feature('feature_odoo')) {
                this.setSnackbar('error', 'No tiene los permisos adecuados para modificar estos valores.')
            }

            if (formIsValid) {
                this.setOdooCredentials(this.odooCredentials)
                .then(() => {
                    this.setSnackbar('success', 'Cambios realizados con éxito.')
                    setTimeout(() => {this.odooDialog = false}, 500)
                })
                .catch(( error ) => {
                    if (error.startsWith('Credenciales incorrectas')) {
                        this.setSnackbar('error', `${error}`)
                    } else
                        this.setSnackbar('error', 'No hemos podido conectar con su servidor. Por favor, compruebe que los datos introducidos son correctos.') 
                })
                .finally(() => {
                    this.odooCredentials.isLoading = false
                })
            } else {
                this.odooCredentials.isLoading = false
                this.setSnackbar('error', 'Compruebe que los valores en el formulario son válidos.')
            }
        },
        
        updateGlasofCredentials() {
            this.glasofCredentials.isLoading = true
            const formIsValid = this.$refs.glasofCredentialsForm.validate()

            if (formIsValid) {
                this.setGlasofCredentials(this.glasofCredentials)
                .then(() => {
                    this.setSnackbar('success', 'Cambios realizados con éxito.')
                    this.forceRefreshUserData();
                    setTimeout(() => {this.glasofDialog = false}, 500)
                })
                .catch(( error ) => {
                    if (error.startsWith('Credenciales incorrectas')) {
                        this.setSnackbar('error', `${error}`)
                    } else
                        this.setSnackbar('error', 'No hemos podido conectar con su servidor. Por favor, compruebe que los datos introducidos son correctos.') 
                })
                .finally(() => {
                    this.glasofCredentials.isLoading = false
                })
            } else {
                this.glasofCredentials.isLoading = false
                this.setSnackbar('error', 'Compruebe que los valores en el formulario son válidos.')
            }
        },

        updateGoldenCredentials() {
            this.goldenCredentials.isLoading = true
            const formIsValid = this.$refs.goldenCredentialsForm.validate()

            //if(!this.got_feature('feature_goldennet')) {
            //    this.setSnackbar('error', 'No tiene los permisos adecuados para modificar estos valores.')
            //}

            if (formIsValid) {
                this.setGoldenCredentials(this.goldenCredentials)
                .then(() => {
                    this.setSnackbar('success', 'Cambios realizados con éxito.')
                    setTimeout(() => {this.goldenDialog = false}, 500)
                })
                .catch(( error ) => {
                    if (error.startsWith('Credenciales incorrectas')) {
                        this.setSnackbar('error', `${error}`)
                    } else
                        this.setSnackbar('error', 'No hemos podido conectar con su servidor. Por favor, compruebe que los datos introducidos son correctos.') 
                })
                .finally(() => {
                    this.goldenCredentials.isLoading = false
                })
            } else {
                this.goldenCredentials.isLoading = false
                this.setSnackbar('error', 'Compruebe que los valores en el formulario son válidos.')
            }
        },
        updateAutoflowCredentials() {
            this.autoflowCredentials.isLoading = true

            const formIsValid = this.$refs.autoflowCredentialsForm && this.$refs.autoflowCredentialsForm.validate
                ? this.$refs.autoflowCredentialsForm.validate()
                : true

            if (!formIsValid) {
                this.setSnackbar('error', 'Compruebe que los valores en el formulario son válidos.')
                this.autoflowCredentials.isLoading = false
                return
            }

            const payload = {
                software: this.autoflowCredentials.software,
                user: this.autoflowCredentials.user,
                password: this.autoflowCredentials.password,
            }

            sync_command_dispatcher
                .dispatch('save.software.credentials.encrypted', { info: payload })
                .then(() => {
                    this.setSnackbar('success', 'Credenciales guardadas correctamente.')
                    setTimeout(() => {
                        this.autoflowDialog = false
                        this.autoflowCredentials.isLoading = false
                    }, 500)
                })
                .catch(() => {
                    this.setSnackbar('error', 'Error al guardar las credenciales.')
                    this.autoflowCredentials.isLoading = false
                })
         },
        create_upgrade_goldennet_install() {            
            this.loading_upgrade_goldennet_install = true;
            client.put('create_operation_no_staff/', { 'params': { 'name': 'UpgradeGoldennetInstall', 'channel': 'rest' }}).then(() => {

            });
            this.loading_upgrade_goldennet_install = false;
            this.disable_upgrade_goldennet = true
        },
        create_upgrade_sage_install() {
            this.loading_upgrade_sage_install = true;
            client.put('create_operation_no_staff/', { 'params': { 'name': 'UpgradeSageInstall', 'channel': 'rest' }}).then(() => {
            });
            this.loading_upgrade_sage_install = false;
            this.disable_upgrade_sage = true
        },
        create_upgrade_glasof_install() {
            this.loading_upgrade_glasof_install = true;
            client.put('create_operation_no_staff/', { 'params': { 'name': 'UpgradeGlasofInstall', 'channel': 'rest' }}).then(() => {
            });
            this.loading_upgrade_glasof_install = false;
            this.disable_upgrade_glasof = true
        },

        updateSageDirectories() {
            this.sageDirectories.isLoading = true

            if(!this.got_feature('feature_sage_self_managing')) {
                this.setSnackbar('error', 'No tiene los permisos adecuados para modificar estos valores.')
            }

            this.setSageCredentials(this.sageDirectories)
            .then(() => {
                this.setSnackbar('success', 'Cambios realizados con éxito.') 
                setTimeout(() => {this.sageDialog = false}, 500)
            })
            .catch(() => { this.setSnackbar('error', 'Ha habido un error durante el proceso.') })
            .finally(() => {
                this.sageDirectories.isLoading = false
            })
        },

        updateSageDespDirectories() {
            this.sageDespDirectories.isLoading = true

            this.setSageDespCredentials(this.sageDespDirectories).then(() => {
                this.setSnackbar('success', 'Cambios realizados con éxito.') 
                setTimeout(() => {this.sageDespDialog = false}, 500)
            }).catch((error) => { 
                this.setSnackbar('error', 'Ha habido un error durante el proceso.') 
            }).finally(() => {
                this.sageDespDirectories.isLoading = false
            })
        },


        setSnackbar(color, text) {
            this.snackbar.text = text
            this.snackbar.color = color
            this.snackbar.isVisible = true
        },
        getFolder(modelName) {
            if (this.isElectron) {
                window.electronAPI.readFolder().then(result => {
                    if (!result.canceled && result.filePaths.length > 0) {
                        _.set(this, modelName, result.filePaths[0]);
                    }
                });
            }
        },
        installService() {
            if (this.isElectron) {
                this.processingService = true;
                const repo = createApiTokenRepository();
                getOrCreateToken(repo).then((result) => {
                    let {token} = result;
                    window.electronAPI.installService(token).then(() => {
                        this.processingService = false;
                        console.log("Installation complete");
                        this.checkConnectorStatus();  
                    });
                });
            }
        },
        uninstallService() {
            if (this.isElectron) {
                
                window.electronAPI.uninstallService().then(() => {
                    this.processingService = false;
                    console.log("Installation complete");
                    this.checkConnectorStatus();  
                });
                
            }
        },
        checkConnectorStatus() {
            if (this.isElectron) {
                this.processingService = true;
                window.electronAPI.checkWsStatus().then((result) => {
                    if (result.status == 'OK') {
                        this.connectorStatus = {color: 'green', text: 'Conectado', status: result.status,connected:true,version:result.version};
                    } else if (result.status == 'KO') {
                        this.connectorStatus = {color: 'red', text: 'Desconectado', status: result.status,connected:false,version:result.version};
                    }
                    this.processingService = false;
                });
            }
        },
        
        async previewBankDialog() {
            let settings = await new GetBankSettingsQuery(new ApiBankRepository(), this).run(this.userData.id)
            console.log(settings)
        },
        
        async saveSettingsColumns(data) {
            try {
                this.isLoading = true 
                this.bankDialogHide = data['hide']
                this.bankDialogShow = data['show']
                let updated_settings = await new SaveBankSettingsCommand(new ApiBankRepository(), this).run() 

                this.setSnackbar('success', 'Cambios realizados con éxito.')
            } catch (e) {
                this.setSnackbar('error', 'Ha habido un error durante el proceso.')
            }        
        },
        async getWindowsConfig(){
            let res = await query_dispatcher.dispatch('get.windows.config.decrypted',{})
            if(res){
                this.windowsCredentials.username = res.username
                this.windowsCredentials.password = res.password
                this.windowsCredentials.domain = res.domain
            } 
        },
        openKitDigitalDialog() {
            this.kitDigitalDialog = true;
        },
        resetKitDigitalDialog() {
            this.kitDigitalDialog = false
            this.kitDigitalCredentials = {
                path: null,
                loading: false
            }
        },
        async updateKitDigitalCredentials() {
            await this.$refs.kitUploader.onClickUpload()
        },
        onSnack(payload) {
            const { type, text } = payload || {}
            this.setSnackbar(type || 'info', text || '')
        },
        onKitDigitalDone({ path }) {
            this.kitDigitalCredentials.path = path
            this.kitDigitalCredentials.loading = false
        },
        onScreenData({ path, loading }) {
            this.kitDigitalCredentials.path = path
            this.kitDigitalCredentials.loading = loading
        }
    },
    
    async mounted() {
        // Diezsoftware saved settings
        if (this.userData.default_settings.diezsoftware) {
            this.diezsoftwareCredentials.user = this.userData.default_settings.diezsoftware.user
            this.diezsoftwareCredentials.password = this.userData.default_settings.diezsoftware.password
            this.diezsoftwareCredentials.softwareType = this.userData.default_settings.diezsoftware.software_type
        }

        this.getColumnsCsvOneLine();
        // this.getColumnsCsvMultiLine();

        this.isElectron = navigator.userAgent == 'InmaticApp';
        this.getWindowsConfig()
        const repo = createApiTokenRepository();
        let {token}  =  await getToken(repo)
        if (token) {
            this.token = token;
        }
        this.initSageDespDialog();
    },
}
</script>
            
@/modules/bank/infra/SettingsRepository